var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "../EventEmitter", "./FileUploadController", "./BasicViewControllerWithCRUDDataSource", "../Shared/KendoDataExtracter"], function (require, exports, EventEmitter_1, FileUploadController_1, BasicViewControllerWithCRUDDataSource_1, KendoDataExtracter_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ContentController = (function (_super) {
        __extends(ContentController, _super);
        function ContentController(options) {
            var _this = _super.call(this) || this;
            _this.viewController = {};
            _this.viewControllerCount = 0;
            _this.uploadedCounter = 0;
            _this.options = options;
            _this.uploadField = $(_this.options.htmlUploadFieldSeletor);
            _this.fileUploadController = new FileUploadController_1.FileUploadController(window["selectedTenant"], {
                Type: "asset",
                createApiUrl: "../api/v1/contents",
                minioClientGetPresignedUrl: "../api/v1/contents/getpresignedurl/",
                autoCreateProgressbars: false,
                minioClientDebug: true,
                autoCreateAssetAfterFileUploaded: false
            });
            _this.fileUploadController.fileSource = _this.uploadField[0];
            _this.fileUploadController.minioClient.AddEventListener("GetPresignedUrlFinished", function (sender, data) { return _this.OnGetPresendUrlFinishedHandler(sender, data); });
            _this.fileUploadController.minioClient.AddEventListener("FileUploaded", function (sender, data) { return _this.OnFileUploadedHandler(sender, data); });
            $(_this.options.htmlUploadFieldSeletor).on("change", function () {
                _this.fileUploadController.Upload();
                _this.createAssetControllers();
            });
            $('.cyb-asset-add').click(function () {
                _this.assetTypeDialog = $.dialog({
                    title: 'Welchen Asset-Type möchten Sie erstellen?',
                    content: "<div style=\"padding-bottom:20px;\">\n                        <a class=\"btn btn-outline-info btn-lg mb-2 mr-3\" href=\"#\" onclick=\"clickFilePicker(); closeNewAssetDialog(); return false;\">Image/Video</a> \n                        <a onclick=\"closeNewAssetDialog();\" class=\"btn btn-outline-info btn-lg mb-2 mr-3\" href=\"/contents/new-website\">Website</a> \n                        <a onclick=\"closeNewAssetDialog();\" class=\"btn btn-outline-info btn-lg mb-2 mr-3\" href=\"/contents/new-stream\">Stream</a> \n                        <a onclick=\"closeNewAssetDialog();\" class=\"btn btn-outline-info btn-lg mb-2 mr-3\" href=\"/contents/new-freetext\">Freitext</a> \n                    </div>",
                    animation: 'zoom',
                    columnClass: 'large',
                    closeAnimation: 'scale',
                    backgroundDismiss: true,
                    closeIcon: true,
                    draggable: false
                });
            });
            window["clickFilePicker"] = function () {
                $(_this.options.htmlUploadFieldSeletor).trigger("click");
            };
            window["closeNewAssetDialog"] = function () {
                _this.assetTypeDialog.close();
            };
            return _this;
        }
        ContentController.prototype.OnFileUploadedHandler = function (sender, data) {
            console.log("file uploaded", data);
            $(this.viewController[data.fileUpload.file.name].vueRoot.$el).find(".update-button").removeAttr("disabled");
            this.uploadedCounter++;
            if (this.uploadedCounter >= this.viewControllerCount) {
                var base_1 = this;
                $('[data-save-all]').each(function () {
                    $(this).click(function () {
                        for (var i in base_1.viewController) {
                            base_1.viewController[i].vueRoot.Update(null);
                        }
                    });
                    $(this).removeAttr("disabled");
                });
            }
        };
        ContentController.prototype.OnGetPresendUrlFinishedHandler = function (sender, data) {
            console.log("GetPresignedUrlFinished", data);
            if (window["CanAccessAllLocations"] == true)
                data.Asset.AssignedLocations = ["all"];
            else
                data.Asset.AssignedLocations = window["assignedLocation"];
            data.Asset.Name = data.fileName;
            KendoDataExtracter_1.KendoDataExtracter.SetKendoDatasourceEntryFromObject(data.Asset, this.viewController[data.fileName].remoteDataSource.at(0));
            this.viewController[data.fileName].vueRoot.model = KendoDataExtracter_1.KendoDataExtracter.GetPlainDataFromKendoDatasourceEntry(this.viewController[data.fileName].remoteDataSource.at(0));
            try {
                var file = sender.fileUploadArray[data.fileName].file;
                var imgs = $(this.viewController[data.fileName].vueRoot.$el).find('.previewimg');
                for (var i = 0; i < imgs.length; i++) {
                    if (file.type.indexOf("video") !== -1) {
                        $(imgs[i]).parents("[id*=vue]").first().find('.accordion-header .previewimg')[0].src = '/lib/universe-admin/dist/admin/img/file-manager/video.png';
                        $(imgs[i]).show();
                    }
                    else if (file.type.indexOf("image") !== -1) {
                        $(imgs[i]).parents("[id*=vue]").first().find('.accordion-header .previewimg')[0].src = '/images/placeholder/image-placeholder.png';
                        $(imgs[i]).show();
                    }
                }
            }
            catch (e) {
                console.log("error @ GetPresignedUrlFinished eventhandler, e:", e);
            }
        };
        ContentController.prototype.createAssetControllers = function () {
            var fileUploadArray = this.fileUploadController.minioClient.GetFileUploads();
            var i = 0;
            var _loop_1 = function (key) {
                var fileUpload = fileUploadArray[key];
                tmp = $(this_1.options.assetsAccordionItemTemplateSelector).html();
                tmp = tmp.replace(/{id-replace}/g, i.toString()).replace(/{file-name}/g, fileUpload.requestObject.fileName);
                if (i === 0)
                    tmp = tmp.replace(/{visible1}/g, "").replace(/{visible2}/g, "true").replace(/{visible3}/g, "show");
                else
                    tmp = tmp.replace(/{visible1}/g, "collapsed").replace(/{visible2}/g, "false").replace(/{visible3}/g, "");
                $(this_1.options.assetsAccordionRootSelector).append($(tmp));
                var vcOptions = {
                    htmlElementSelector: "#vue" + i,
                    type: 'Asset',
                    IsInEditMode: false,
                    createApiUrl: "/api/v1/contents",
                    readApiUrl: null,
                    updateApiUrl: "/api/v1/contents",
                    destroyApiUrl: null
                };
                var viewController = new BasicViewControllerWithCRUDDataSource_1.BasicViewControllerWithCRUDDataSource(vcOptions);
                KendoDataExtracter_1.KendoDataExtracter.SetKendoDatasourceEntryFromObject(fileUpload.requestObject.Asset, viewController.remoteDataSource.at(0));
                viewController.vueRoot.model = KendoDataExtracter_1.KendoDataExtracter.GetPlainDataFromKendoDatasourceEntry(viewController.remoteDataSource.at(0));
                var progressField = $('.progress-bar', "#vue" + i);
                fileUpload.AddEventListener("FileProgress", function (sender, data) {
                    var progress = (data.progress * 100).toFixed(2);
                    progressField.css('width', progress + '%').attr('valuenow', progress).html(progress + '%');
                });
                this_1.viewController[key] = viewController;
                i++;
            };
            var this_1 = this, tmp;
            for (var key in fileUploadArray) {
                _loop_1(key);
            }
            this.viewControllerCount = i;
            try {
                $("#listView,.filter,#more_filters").slideUp();
            }
            catch (e) {
            }
            $(this.options.assetsAccordionRootSelector).show();
            $('[data-save-all]').show();
        };
        return ContentController;
    }(EventEmitter_1.EventEmitter));
    exports.ContentController = ContentController;
    $(window).on("init-content-controller", function () {
        var optionsList = window["ContentControllerData"];
        for (var i in optionsList) {
            window["ContentController" + i] = new ContentController(optionsList[i]);
        }
    });
});
//# sourceMappingURL=ContentController.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Controllers/ContentController.js
// module id = 391
// module chunks = 0